import { UseMutationOptions, useQuery } from '@tanstack/react-query';

import { useThrottledMutation as useMutation } from '@hooks/use-throttled-mutation';
import { useScopedTranslate } from '@locale/translate';

import { handleError } from 'api/query-client';

import {
  editPreboarding,
  loadPreboardingTeams,
  createPreboardingTeams,
  PreboardingTeams,
} from './request';

export const useEditPreboarding = (options?: UseMutationOptions<unknown, unknown, FormData>) => {
  const { t } = useScopedTranslate(locale);

  return useMutation({
    ...options,
    mutationFn: (data) => editPreboarding(data),
    onError: () => {
      handleError(t('userNotEdited'));
    },
  });
};

export const useLoadPreboardingTeams = () => {
  return useQuery({
    keepPreviousData: true,
    queryKey: ['preboarding-teams'],
    queryFn: loadPreboardingTeams,
  });
};

export const useCreatePreboardingTeams = (
  options?: UseMutationOptions<unknown, unknown, PreboardingTeams>
) => {
  const { t } = useScopedTranslate(locale);

  return useMutation({
    ...options,
    mutationFn: (data: PreboardingTeams) => createPreboardingTeams(data),
    onError: () => {
      handleError(t('userNotEdited'));
    },
  });
};

const locale = {
  en: {
    userNotEdited: 'User not updated',
  },
};
